import type { Permission } from '@/types/api';

/** Group permissions by their backend category (SECURITY, MENU, ...). */
export function groupPermissionsByCategory(
  permissions: Permission[]
): Record<string, Permission[]> {
  return permissions.reduce((acc, permission) => {
    const category = permission.category || 'OTHER';
    (acc[category] ||= []).push(permission);
    return acc;
  }, {} as Record<string, Permission[]>);
}

/** Human-readable label for a permission. */
export function permissionLabel(permission: Permission): string {
  return permission.displayName || permission.name;
}
